<div class="footer-wrapper">
  <div>&copy;
    {{settings?.app?.year}}
    {{ settings?.app?.name }}
  </div>
  <div>
    <a [href]="settings?.app?.complainceLink" target="_blank">{{ settings?.app?.complainceDescription }}</a>
  </div>
</div>